import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { IPreferenceFlorist } from './florist.types';

@Timestampable
@Untrackable
export class PreferenceFlorist extends AbstractDocument<IPreferenceFlorist> {
  readonly collections = {};
}
